export default __webpack_public_path__ + "static/media/gallery-image-6-full.609a06e7.jpg";